// source: PublicMiniTickerV3Api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.PublicMiniTickerV3Api', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PublicMiniTickerV3Api = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PublicMiniTickerV3Api, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PublicMiniTickerV3Api.displayName = 'proto.PublicMiniTickerV3Api';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PublicMiniTickerV3Api.prototype.toObject = function(opt_includeInstance) {
  return proto.PublicMiniTickerV3Api.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PublicMiniTickerV3Api} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicMiniTickerV3Api.toObject = function(includeInstance, msg) {
  var f, obj = {
symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
price: jspb.Message.getFieldWithDefault(msg, 2, ""),
rate: jspb.Message.getFieldWithDefault(msg, 3, ""),
zonedrate: jspb.Message.getFieldWithDefault(msg, 4, ""),
high: jspb.Message.getFieldWithDefault(msg, 5, ""),
low: jspb.Message.getFieldWithDefault(msg, 6, ""),
volume: jspb.Message.getFieldWithDefault(msg, 7, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 8, ""),
lastcloserate: jspb.Message.getFieldWithDefault(msg, 9, ""),
lastclosezonedrate: jspb.Message.getFieldWithDefault(msg, 10, ""),
lastclosehigh: jspb.Message.getFieldWithDefault(msg, 11, ""),
lastcloselow: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PublicMiniTickerV3Api}
 */
proto.PublicMiniTickerV3Api.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PublicMiniTickerV3Api;
  return proto.PublicMiniTickerV3Api.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PublicMiniTickerV3Api} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PublicMiniTickerV3Api}
 */
proto.PublicMiniTickerV3Api.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSymbol(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setZonedrate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setHigh(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLow(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVolume(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setQuantity(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastcloserate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastclosezonedrate(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastclosehigh(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastcloselow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PublicMiniTickerV3Api.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PublicMiniTickerV3Api.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PublicMiniTickerV3Api} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicMiniTickerV3Api.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getZonedrate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHigh();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLow();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getVolume();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getQuantity();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLastcloserate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLastclosezonedrate();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLastclosehigh();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLastcloselow();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string price = 2;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string rate = 3;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setRate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string zonedRate = 4;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getZonedrate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setZonedrate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string high = 5;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getHigh = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setHigh = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string low = 6;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getLow = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setLow = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string volume = 7;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getVolume = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setVolume = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string quantity = 8;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getQuantity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string lastCloseRate = 9;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getLastcloserate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setLastcloserate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string lastCloseZonedRate = 10;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getLastclosezonedrate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setLastclosezonedrate = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string lastCloseHigh = 11;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getLastclosehigh = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setLastclosehigh = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string lastCloseLow = 12;
 * @return {string}
 */
proto.PublicMiniTickerV3Api.prototype.getLastcloselow = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicMiniTickerV3Api} returns this
 */
proto.PublicMiniTickerV3Api.prototype.setLastcloselow = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


goog.object.extend(exports, proto);
